export var BulkDownloadInvoiceTaskStatus;
(function (BulkDownloadInvoiceTaskStatus) {
    BulkDownloadInvoiceTaskStatus["PENDING"] = "pending";
    BulkDownloadInvoiceTaskStatus["IN_PROGRESS"] = "in_progress";
    BulkDownloadInvoiceTaskStatus["COMPLETED"] = "completed";
    BulkDownloadInvoiceTaskStatus["FAILED"] = "failed";
})(BulkDownloadInvoiceTaskStatus || (BulkDownloadInvoiceTaskStatus = {}));
//# sourceMappingURL=bulkDownloadInvoiceTask.js.map